import React from 'react';
import MoodleLesson from '../../../../Moodle/Lesson/MoodleLesson';
import { MoodleInstanceKey } from '../../../../../../support/slices/moodleSlice';

interface Props {
  courseId: string;
  lessonId: number;
  instance: MoodleInstanceKey;
}

export default function MoodleLessonRenderer({ courseId, lessonId, instance }: Props) {
  return (
    <div style={{ padding: '1.5rem' }}>
      <MoodleLesson lessonId={lessonId} courseId={courseId} instance={instance} />
    </div>
  );
}